import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tx8dz6jy5e: FaireBrandEntity = {
  token: "b_tx8dz6jy5e",
  type: "brand",
  name: "Oolio",
  avatarUrl:
    "https://cdn.faire.com/fastly/ca39ce43a9c005bea5886b5187a88e50aef61d7e0814c931aebbb35a89dae587.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/55294d82d14ede0a757f79f9c897d94768199c34b0c3c08b6c593f4610b76ec7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ca39ce43a9c005bea5886b5187a88e50aef61d7e0814c931aebbb35a89dae587.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/55294d82d14ede0a757f79f9c897d94768199c34b0c3c08b6c593f4610b76ec7.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Made for passing, pouring and sharing! \n\nOolio is extra virgin olive oil, reimagined. Rooted in our native 4th generation Sicilian family groves, every drop is hand-harvested, cold-extracted, packed with polyphenols and organic—crafted with care to deliver bold flavor and vibrant design to the everyday kitchen.\n\nWe created Oolio to feel as joyful as it tastes: something you’ll drizzle on everything, proudly display on your counter, and share around the table. But Oolio is more than just olive oil—it’s a lifestyle. From playlists to supper clubs, recipes to community, we celebrate food as a way to connect.\n\nSustainability is at the heart of what we do. With a no-waste practice and a promise to leave the world better than we found it, we believe no one is perfect—but we can all do our part, one olive at a time.\n\nOolio is where bold flavor, playful design, and conscious sourcing meet—crafted to stand out on shelves and shine in kitchens! ",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:08.816Z",
    importedBy: "entity-db-cli",
  },
};
